import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
const originalPush = VueRouter.prototype.push;
const flag = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
);
const postId = localStorage.getItem("iuPost") * 1;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);
//console.log(flag);
const routes = [
  {
    path: "",
    redirect: "/dologin",
  },

  {
    path: "/dologin",
    name: "dologin",
    component: () => import("../views/doLogin.vue"),
    meta: {
      title: "登录",
    },
  },

  {
    path: "/Home",
    name: "Home",
    component: () => import("../views/Home.vue"),
    children: [
      {
        path: "",
        redirect: "/Home/userList",
      },
      {
        path: "userList",
        name: "userList",
        component: () => import("../views/user/userList"),
      },
      {
        path: "commercialTenant",
        name: "commercialTenant",
        component: () => import("../views/commercialTenant/commercialTenant"),
      },
      {
        path: "MerchantBill",
        name: "MerchantBill",
        component: () => import("../views/MerchantBill/MerchantBill"),
      },

      {
        path: "withdrawal",
        name: "withdrawal",
        component: () => import("../views/MerchantBill/withdrawal"),
      },
      {
        path: "wxBill",
        name: "wxBill",
        component: () => import("../views/MerchantBill/wxBill"),
      },
      {
        path: "InvoiceReminder",
        name: "InvoiceReminder",
        component: () => import("../views/InvoiceReminder/InvoiceReminder"),
      },
      {
        path: "SystemLog",
        name: "SystemLog",
        component: () => import("../views/sysLog/SystemLog"),
      },
      {
        path: "OptionalBankRange",
        name: "OptionalBankRange",
        component: () => import("../views/OptionalBankRange/OptionalBankRange"),
      },
      {
        path: "InvoiceType",
        name: "InvoiceType",
        component: () => import("../views/InvoiceReminder/InvoiceType"),
      },
      {
        path: "MerchantUser",
        name: "MerchantUser",
        component: () => import("../views/MerchantUser/MerchantUser"),
      },
      {
        path: "cityList",
        name: "cityList",
        component: () => import("../views/cityList/cityList"),
      },
      {
        path: "authority",
        name: "authority",
        component: () => import("../views/authority/authority"),
      },
      {
        path: "role",
        name: "role",
        component: () => import("../views/authority/role"),
      },
      {
        path: "InvoiceTypeSh",
        name: "InvoiceTypeSh",
        component: () => import("../views/InvoiceTypeSh/InvoiceTypeSh"),
      },

      {
        path: "goods",
        name: "goods",
        component: () => import("../views/goods/goods"),
      },
      {
        path: "goodsList",
        name: "goodsList",
        component: () => import("../views/goods/goodsList"),
      },

      {
        path: "merchartsCity",
        name: "merchartsCity",
        component: () => import("../views/commercialTenant/merchartsCity"),
      },
      {
        path: "keysMsg",
        name: "keysMsg",
        component: () => import("../views/keysMsg/keysMsg"),
      },
      {
        path: "yiBaoTongPush",
        name: "yiBaoTongPush",
        component: () => import("../views/yiBaoTongPush/yiBaoTongPush"),
      },
      {
        path: "yiBaoTongOrderAfterSale",
        name: "yiBaoTongOrderAfterSale",
        component: () =>
          import("../views/yiBaoTongPush/yiBaoTongOrderAfterSale"),
      },
      {
        path: "wxUser",
        name: "wxUser",
        component: () => import("../views/wxUser/wxUser"),
      },
      {
        path: "billList",
        name: "billList",
        component: () => import("../views/billList/billList"),
      },
       {
        path: "logActivityStatistics",
        name: "logActivityStatistics",
        component: () => import("../views/sysLog/logActivityStatistics"),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
